import { Component, OnInit } from '@angular/core';

import { ProgressService } from '../../../services';

@Component({
    selector: 'myprogress',
    template: require('./progress.component.html')
})

export class ProgressComponent implements OnInit {
    message: any;

    constructor(private progressService: ProgressService) { }

    ngOnInit() {
        this.progressService.getMessage().subscribe(message => { this.message = message; });
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/components/common/progress/progress.component.ts